import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BqsService } from '../Service/bqs.service';

/**
 * Class for the sign up
 * 
 * @export
 * @class SuccessComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'success',
    template: require('./success.component.html'),
    styles: [require('./success.component.css')],
    encapsulation: ViewEncapsulation.None
})
export class SuccessComponent implements OnInit {

    private contractNumber: string;
    private documentID: string;
    private creditCheckReference: string;

    constructor(private BQS: BqsService, private route: ActivatedRoute) { }

    public ngOnInit() {
        if (this.route != null && this.route.params != null) {
            this.route.params.subscribe((params) => {
                this.contractNumber = params['contractNumber'];
                this.documentID = params['documentID'];
                this.creditCheckReference = params['creditCheckReference'];
                this.completeAccountApplication();
            });
        }
    }

    public completeAccountApplication() {
        if (this.contractNumber != null && this.creditCheckReference != null && this.documentID != null) {
            this.BQS.completeAccountApplication(this.contractNumber, this.creditCheckReference, this.documentID)
                .subscribe((x) => null);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Success/success.component.ts
 **/